<template>
<div class='drop-down-select-wrap'>
  <div @click='open = !open' v-if='selectedItem'>
    <span class='selected-option'>{{selectedItem.name}}</span>
    <DownArrow :class='{open: open}' />
  </div>
  <transition name='drop-fade'>
    <span class='selection' v-if='open'>
      <ul>
        <li v-for='(option, i) in options' :key='i' @click='handleSelection(option)'>{{option.option.name}}</li>
      </ul>
    </span>
  </transition>
  <div v-if='open' class='bg_click' @click='open = !open'></div>
</div>
</template>
<script>
import DownArrow from '$svgs/DownArrow.vue'
export default {
  props: {
    options: {
      type: Array,
      required: true,
      default: function () {
        return []
      }
    },
    selectedItem: {
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      open: false
    }
  },

  watch: {
    options: function (value) {}
  },

  methods: {
    handleSelection (option) {
      this.$emit('selected', option)
      this.open = false
    }
  },

  mounted () {},

  components: {
    DownArrow
  }
}
</script>
<style lang='scss' scoped>
.drop-down-select-wrap{
  position: relative;
  cursor: pointer;
  width: 100%;
  .oi{
    color:#E3E3E3;
    position: absolute;
    right:0;
  }
  .selected-option{
    display: block;
    @include font-size(1.2);
    color:#E3E3E3;
    @include type_bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .icon{
    position: absolute;
    top:-3px;
    right:0;
    width:1rem;
    height:1rem;
    transform-origin: center;
    transform: rotateZ(0deg);
    &.open{
      transform: rotateZ(180deg) translate3d(0, -10px, 0);
    }
  }
  .selection{
    display: block;
    position: absolute;
    top:2.5rem;
    width: 100%;
    background-color:#E3E3E3;
    z-index: 2;
    ul{
      position: relative;
      margin:0;
      padding:1rem;
      width:100%;
      height:13rem;
      overflow-y: scroll;
      li{
        list-style-type: none;
        @include font-size(1);
        transition: all 0.2s ease-in-out;
        padding:0.25rem 1rem;
        background-color:rgba(0, 0, 0, 0);
        border-radius:0.2rem;
        &:hover{
          color:$c_pure_blue;
          background-color:rgba(0, 0, 0, 0.05);
        }
      }
    }
    &:before{
      content:'';
      display: block;
      position: absolute;
      top:-5px;
      left:50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid #E3E3E3;
    }
  }
  .bg_click{
    @include full_wh;
    position: fixed;
    z-index: 1;
  }
  .drop-fade-enter-active, .drop-fade-leave-active {
    transition: all .2s;

  }
  .drop-fade-enter, .drop-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform:translate3d(0, -10px, 0);
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/gold-admin/AdminDropDownSelect.vue